import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateConfigPtMonMedidor } from "./services";

const initialState: any = {
  status: "",
  data: null,
  msgError: "",
};

export const actionUpdateConfigPtMonMedidor: any = createAsyncThunk<any, any>(
  "ACTION_UPDATE_CONFIG_PT_MON_MEDIDOR",
  async (data, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
      getPtMonMedidor,
      equipamentos: { dataUnidadeDeMedida },
    } = getState();

    const result = await updateConfigPtMonMedidor(getPtMonMedidor.data.id, {
      ...data,
      idLoja: lojaSelected,
    });

    return result.data;
  }
);

const sliceUpdateConfigPtMonMedidor = createSlice({
  name: "UPDATE_CONFIG",
  initialState,
  reducers: {
    actionResetStateUpdadePtMonMedidor: (state) => {
      state.status = "";
      state.msgError = "";
    },
  },
  extraReducers: {
    [actionUpdateConfigPtMonMedidor.pending]: (state) => {
      state.status = "loading";
    },
    [actionUpdateConfigPtMonMedidor.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionUpdateConfigPtMonMedidor.rejected]: (
      state,
      { error: { message } }
    ) => {
      state.status = "error";
      state.msgError = message;
    },
  },
});

export default sliceUpdateConfigPtMonMedidor.reducer;
export const { actionResetStateUpdadePtMonMedidor } =
  sliceUpdateConfigPtMonMedidor.actions;
